// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__12yYg","icon":"style_icon__1n0_m"};